<script type="text/javascript">
	import { beforeUpdate } from "svelte";
	export let degrees = "0";
	export let adjust = 0;


	let getStyle = () => {
		let degreesAdjusted = parseFloat(degrees)+adjust;
		return "display:inline-block;vertical-align:middle;line-height:12px;transform:rotate("+degreesAdjusted+"deg)"; ;
	}
	let style = "";

	beforeUpdate(() => {
		style = getStyle();
	});
</script>

{#if degrees !== "N/A"}
	<span class="material-icons" style={style}>arrow_right_alt</span>
{/if}
